import { Locale } from '../types/apollo/generated/types.generated';
import { User } from '../types/sharetribe/user';

enum Language {
  EN = 'en',
  FR = 'fr',
  DE = 'de',
  NL = 'nl',
  ES = 'es',
  IT = 'it',
}

export const getLanguageFromLocale = (locale: Locale): Language =>
  locale.split('_')[0].toLowerCase() as Language;

const getWeglot = () => {
  if (typeof window !== 'undefined') return (window as any).Weglot;
  return null;
};

/* Initialize Weglot with the user's preferred language.
Language code must be lowercase.
*/
export const setWeglotLanguageToUserPreferredLanguage = (currentUser: User) => {
  const weglot = getWeglot();
  if (weglot) {
    const preferredLocale = currentUser.attributes.profile.privateData?.preferredLocale;
    const preferredLanguage = preferredLocale
      ? getLanguageFromLocale(preferredLocale)
      : Language.EN;
    weglot.switchTo(preferredLanguage);
  }
};

const LANGUAGE_TO_DEFAULT_LOCALE = {
  [Language.EN]: Locale.EnUs,
  [Language.FR]: Locale.FrFr,
  [Language.DE]: Locale.DeDe,
  [Language.ES]: Locale.EsEs,
  [Language.IT]: Locale.ItIt,
  [Language.NL]: Locale.NlNl,
};

export const getDefaultLocaleForLanguage = (language: Language): Locale | undefined =>
  LANGUAGE_TO_DEFAULT_LOCALE[language];
